import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Activities'

export const ACTIVITIES_PER_PAGE = 100
export const ACTIVITIES_CSV_PER_PAGE = 100000
export const DEFAULT_PAGE_NUMBER = 1
export const AD_SYNC = 8

export const FETCH_ACTIVITIES_ASYNC = createAsyncTypes('FETCH_ACTIVITIES', typeKey)
export const FETCH_ACTIVITIES_CSV_ASYNC = createAsyncTypes('FETCH_ACTIVITIES_CSV', typeKey)
export const FETCH_ALL_FILTERS_ASYNC = createAsyncTypes('FETCH_ALL_FILTERS_ASYNC', typeKey)

export const EVENTS_FILTER_CHANGE = `${typeKey}/EVENTS_FILTER_CHANGE`
export const CREATED_BY_FILTER_CHANGE = `${typeKey}/CREATED_BY_FILTER_CHANGE`
export const TARGETS_FILTER_CHANGE = `${typeKey}/TARGETS_FILTER_CHANGE`
export const PAGINATE_CHANGE = `${typeKey}/PAGINATE_CHANGE`
export const DATE_FILTER_CHANGE = `${typeKey}/DATE_FILTER_CHANGE`
export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SEARCH_RESET = `${typeKey}/SEARCH_RESET`
export const SORT_PROPERTY_CHANGE = `${typeKey}/SORT_PROPERTY_CHANGE`

export const TARGET_CAMPAIGNS = 6
